import { Button, Switch } from "antd";
import type { ColumnsType } from "antd/es/table";
import dayjs from 'dayjs';
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";
import { SettingsServer } from "./../../../server";

const server = SettingsServer.Config

const lang = langPage?.settings?.config;


export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, setLoading, refresh } = props;

    return [
        {
            title: lang?.mark,
            dataIndex: "Name",
        },
        {
            title: lang?.remark,
            dataIndex: "Remark",
        },
        {
            title: lang?.sort,
            dataIndex: "Sort",
        },
        {
            title: langCommon?.status,
            dataIndex: "Status",
            render: (_: any, row: any) => {
                return <Switch
                    checkedChildren={langCommon?.enabled}
                    unCheckedChildren={langCommon?.disable}
                    checked={row.Status === 1}
                    onChange={async (checked) => {
                        setLoading(true);
                        try {
                            const { CreatedAt, UpdatedAt, ...otherProps } = row;
                            await server.enabled({ ...otherProps, Status: checked })
                            refresh?.();
                        } catch (error) {
                        }
                        setLoading(false);
                    }}
                />;
            }
        },
        {
            title: lang?.title,
            dataIndex: "Title",
        },
        {
            title: lang?.type,
            dataIndex: "Type",
        },
        {
            title: lang?.value,
            dataIndex: "Value",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAt",
            render: (val) => {
                return val ? dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss') : '-'
            }
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 100,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => operationRef?.current?.changeVisible({
                                ...row,
                                FundPassword: row.FundPasswordHash,
                                Password: row.PasswordHash,
                                MemberId: row.Id
                            }, 'modify')}
                        >{langCommon?.modify}</Button>
                        {/* <Popconfirm title={langCommon?.deleteItem} onConfirm={() => deleteData?.({ Id: row.Id })} >
                            <Button size="small" type="link" loading={loading} className="pdl0 pdr0">{langCommon?.delete}</Button>
                        </Popconfirm> */}
                    </div>
                )
            }
        }
    ]
}

export const DEFAULT_OPERATION_DATA = {
    Name: null,
    Remark: null,
    Sort: 1,
    Title: null,
    Status: 1,
    Type: null,
    Value: null,
}

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    return [
        {
            title: lang?.mark,
            type: "input",
            field: "Name",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.mark}`
            }]
        },
        {
            title: lang?.title,
            type: "input",
            field: "Title",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.title}`
            }]
        },
        {
            title: lang?.remark,
            type: "input",
            field: "Remark",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.remark}`
            }]
        },
        {
            title: lang?.type,
            type: "input",
            field: "Type",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.type}`
            }]
        },
        {
            title: lang?.value,
            type: "input",
            field: "Value",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.value}`
            }]
        },
        {
            title: lang?.sort,
            type: "inputNumber",
            field: "Sort",
            style: { width: 200 },
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.sort}`
            }]
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            style: { width: 200 },
            options: [
                { id: 1, name: langCommon?.enabled },
                { id: 2, name: langCommon?.disable }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${langCommon?.status}`
            }]
        },
    ];
}